import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Connect a property's Airbnb listing through Channex, inside HostFolio. The backend sets the unit
// up on Channex and returns a one-time link to Channex's channel screen, limited to Airbnb.
export default function ChannexConnect({ propertyId }) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/channex/connect-session/${propertyId}`);
      setUrl(data.url);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not open the Airbnb connection screen");
    } finally { setBusy(false); }
  };

  return (
    <div className="border-t border-slate-100 dark:border-slate-700 px-5 py-4 flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="text-xs font-semibold text-slate-700 dark:text-slate-200">Airbnb via Channex <span className="ml-1 text-[10px] px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300">Beta, admin only</span></p>
        <p className="text-[11px] text-slate-400">Guest messages, booking requests and reviews. An Airbnb account can use one channel manager, so this replaces Aiosell for Airbnb.</p>
      </div>
      <button onClick={open} disabled={busy}
        className="px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white text-xs font-semibold rounded-xl transition disabled:opacity-50 shrink-0">
        {busy ? "Opening…" : "Connect Airbnb"}
      </button>
      <Dialog open={!!url} onOpenChange={(o) => !o && setUrl(null)}>
        <DialogContent className="max-w-5xl w-[calc(100vw-2rem)] p-0 overflow-hidden">
          <DialogHeader className="px-5 pt-4">
            <DialogTitle>Connect Airbnb</DialogTitle>
            <DialogDescription>Sign in to Airbnb and map the listing to this property. Close this window when done.</DialogDescription>
          </DialogHeader>
          {url && <iframe title="Connect Airbnb" src={url} className="w-full h-[75vh] border-0" />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
